import React,{useEffect} from 'react';
import { useParams } from 'react-router-dom';
import './TherapyDetail.css';
import Layout from '../../components/Layout';
import pelvic from '../../images/servicetherapy/pelvic floor.jpeg';
import sports from '../../images/servicetherapy/sports rehabilitation.jpeg';
import manual from '../../images/servicetherapy/Manual Therapy.jpeg';
import postsurgical from '../../images/servicetherapy/Post-Surgical Rehabilitation.jpeg';
import Chronic from '../../images/servicetherapy/Chronic Pain Management.jpeg';
import DryNeedling from '../../images/servicetherapy/Dry Needling.jpeg';
import Cupping from '../../images/servicetherapy/Cupping.jpeg';
import TENS from '../../images/servicetherapy/TENS.jpeg';
import EStim from '../../images/servicetherapy/E-Stim.jpeg';
import Kinesiology from '../../images/servicetherapy/Kinesiology.jpeg';
import Heat from '../../images/servicetherapy/Heat and Cold.jpeg';
import pelvic1 from '../../images/therapyimages/pelvic.jpg';
import sports1 from '../../images/therapyimages/sports.jpg';
import manual1 from '../../images/therapyimages/manual.jpg';
import postsurgical1 from '../../images/therapyimages/Post-Surgical.jpg';
import Chronic1 from '../../images/therapyimages/chronic.jpg';
import DryNeedling1 from '../../images/therapyimages/dry.jpg';
import Cupping1 from '../../images/therapyimages/Cupping Therapy.jpg';
import TENS1 from '../../images/therapyimages/TENS.jpg';
import EStim1 from '../../images/therapyimages/estem.jpg';
import Kinesiology1 from '../../images/therapyimages/Kinesiology Taping.jpg';
import Heat1 from '../../images/therapyimages/heatandcold.jpeg';
import bgim from '../../images/bgth5.jpeg';
import QuotesSlider from '../Landingpage/QuotesSlider';

const services = {
    therapy1: {
        id: 1,
        therapy: "Pelvic Floor Therapy",
        description: "Pelvic floor therapy is a specialized physiotherapy focusing on muscles, ligaments, and connective tissues that support pelvic organs. It addresses pelvic pain, urinary incontinence, constipation, and sexual dysfunction caused by childbirth, surgery, injury, aging, or chronic conditions.",
        whyChoose: "MantraFlex offers expert care for both men and women, creating a safe and supportive environment. We provide education, manual therapy, and personalized exercise regimens to improve pelvic floor muscle strength and coordination.",
        benefits: [
            "Urinary Incontinence: Strengthens pelvic muscles to improve bladder control.",
            "Pelvic Pain Relief: Alleviates chronic pelvic pain caused by various conditions.",
            "Postpartum Recovery: Restores pelvic muscle strength after childbirth.",
            "Sexual Health: Improves muscle tone and coordination for sexual health.",
            "Constipation Relief: Enhances bowel function through pelvic muscle strengthening."
        ],
        image1: pelvic,
        image2: pelvic1
    },
    therapy2: {
        id: 2,
        therapy: "Sports Rehabilitation",
        description: "Sports rehabilitation focuses on recovery and injury prevention related to athletic activities. It helps athletes, from professionals to amateurs, return to peak performance while preventing future injuries.",
        whyChoose: "At MantraFlex, our physiotherapists provide tailored rehabilitation services for injury recovery and performance enhancement. We focus on sport-specific rehabilitation to ensure effective and safe recovery.",
        benefits: [
            "Injury Recovery: Accelerates recovery from injuries like sprains and fractures.",
            "Injury Prevention: Addresses muscle imbalances and joint instability.",
            "Performance Enhancement: Improves flexibility, strength, and movement patterns.",
            "Sport-Specific Training: Provides custom training programs for a safe return to activity."
        ],
        image1: sports1,
        image2: sports
    },
    therapy3: {
        id: 3,
        therapy: "Manual Therapy",
        description: "Manual therapy involves hands-on techniques to manipulate the body’s joints, muscles, and soft tissues to alleviate pain, improve mobility, and reduce tension. It is used to treat musculoskeletal conditions and injuries.",
        whyChoose: "Manual therapy at MantraFlex is tailored to individual needs, whether dealing with neck or back pain, joint stiffness, or soft tissue injuries. Our expert physiotherapists use effective techniques to provide relief and improve movement.",
        benefits: [
            "Pain Relief: Reduces musculoskeletal pain and headaches.",
            "Improved Mobility: Restores range of motion and flexibility.",
            "Muscle Relaxation: Alleviates muscle tightness and spasms.",
            "Joint Stiffness: Helps with arthritis and joint function improvement."
        ],
        image1: manual1,
        image2: manual
    },
    therapy4: {
        id: 4,
        therapy: "Post-Surgical Rehabilitation",
        description: "Post-surgical rehabilitation helps individuals recover after surgery, such as joint replacement or spinal surgery. It aids in restoring function, reducing pain, and preventing complications during recovery.",
        whyChoose: "At MantraFlex, we provide customized post-surgical rehab plans in collaboration with your surgeon, focusing on accelerating healing, restoring strength, and reducing the risk of complications.",
        benefits: [
            "Accelerated Recovery: Speeds up the healing process through early mobilization.",
            "Restoration of Function: Restores strength, range of motion, and stability.",
            "Pain Management: Alleviates pain and swelling during recovery.",
            "Prevention of Complications: Reduces the risk of muscle weakness and stiffness."
        ],
        image1: postsurgical1,
        image2: postsurgical
    },
    therapy5: {
        id: 5,
        therapy: "Chronic Pain Management",
        description: "Chronic pain persists for over 12 weeks and can arise from conditions like arthritis or nerve damage. It can affect both physical and mental well-being, reducing quality of life.",
        whyChoose: "MantraFlex takes a holistic approach to chronic pain management, addressing both the physical and emotional aspects of pain to improve mobility and overall quality of life.",
        benefits: [
            "Comprehensive Pain Relief: Manages pain from conditions like arthritis and fibromyalgia.",
            "Improved Mobility: Increases flexibility and range of motion.",
            "Enhanced Mental Well-being: Alleviates the emotional impact of chronic pain.",
            "Personalized Treatment: Tailored pain management strategies."
        ],
        image1: Chronic1,
        image2: Chronic
    },
    therapy6: {
        id: 6,
        therapy: "Dry Needling",
        description: "Dry needling involves inserting fine needles into trigger points in muscles or fascia to relieve pain, improve mobility, and promote healing. It targets muscle tightness and dysfunction.",
        whyChoose: "MantraFlex uses advanced dry needling techniques as part of a comprehensive treatment plan for musculoskeletal pain, chronic tension, and sports injuries, providing fast and effective relief.",
        benefits: [
            "Pain Relief: Reduces muscle pain and discomfort.",
            "Improved Range of Motion: Restores normal movement and flexibility.",
            "Reduced Muscle Spasms: Alleviates spasms causing pain and restricted movement.",
            "Accelerated Healing: Stimulates blood flow to promote faster recovery.",
            "Chronic Pain Management: Effective for conditions like myofascial pain syndrome."
        ],
        image1: DryNeedling1,
        image2: DryNeedling
    },
    therapy7: {
        id: 7,
        therapy: "Cupping Therapy",
        description: "Cupping therapy is an ancient healing practice that involves placing specialized cups on the skin to create suction, which increases blood flow, relieves muscle tension, promotes healing, and improves overall well-being. There are two types: dry cupping (without needles) and wet cupping (with small skin incisions).",
        whyChoose: "MantraFlex uses dry cupping to effectively treat musculoskeletal issues, chronic pain, and muscle stiffness. It complements other therapies and enhances recovery by improving circulation and relieving tension.",
        benefits: [
            "Muscle Relaxation: Releases tight muscles and soft tissues.",
            "Improved Circulation: Draws blood to the surface, speeding recovery.",
            "Pain Relief: Reduces discomfort from conditions like arthritis and fibromyalgia.",
            "Detoxification: Stimulates the lymphatic system for toxin removal.",
            "Reduction of Inflammation: Alleviates pain and swelling."
        ],
        image1: Cupping1,
        image2: Cupping
    },
    therapy8: {
        id: 8,
        therapy: "TENS Machine",
        description: "TENS (Transcutaneous Electrical Nerve Stimulation) uses low-voltage electrical currents to relieve pain by sending electrical impulses through the skin, disrupting pain signals and stimulating natural painkillers (endorphins).",
        whyChoose: "At MantraFlex, TENS is a non-invasive, drug-free pain relief solution used for acute and chronic pain, including conditions like back pain, neck pain, arthritis, and muscle spasms.",
        benefits: [
            "Pain Relief: Uses electrical stimulation to block pain signals.",
            "Improved Circulation: Promotes blood flow to affected areas.",
            "Non-invasive: A safe, drug-free treatment option.",
            "Versatile: Effective for both acute and chronic pain."
        ],
        image1: TENS1,
        image2: TENS
    },
    therapy12: {
        id: 12,
        therapy: 'Electrical Stimulation Therapy (E-Stim)',
        description: 'Electrical Stimulation Therapy (E-Stim) uses electrical currents to stimulate muscles, improve muscle strength, and promote muscle function. It can be used to improve neuromuscular function, reduce pain, or prevent muscle atrophy during rehabilitation.',
        benefits: [
            'Promotes muscle contraction and strength',
            'Improves circulation and tissue healing',
            'Reduces muscle atrophy after injury or surgery',
            'Alleviates pain and muscle spasms'
        ],
        whyChoose: 'E-Stim is highly effective for patients recovering from surgery, injury, or stroke. It’s used to stimulate muscles, increase circulation, and reduce muscle wasting or weakness during rehabilitation.',
        image1: EStim1,
        image2: EStim
    },
    therapy13: {
        id: 13,
        therapy: 'Kinesiology Taping',
        description: 'Kinesiology taping involves applying a special elastic tape to the skin to support muscles and joints without restricting movement. The tape is designed to mimic the skin’s elasticity, promoting pain relief, reducing swelling, and supporting muscle function during activity.',
        benefits: [
            'Provides muscle and joint support without restricting movement',
            'Reduces swelling and inflammation',
            'Improves circulation and lymphatic drainage',
            'Enhances proprioception and movement awareness'
        ],
        whyChoose: 'This technique is commonly used for athletes and individuals recovering from injuries. Kinesiology taping provides support to muscles and joints while encouraging natural movement and improving proprioception (the body’s sense of position).',
        image1: Kinesiology1,
        image2: Kinesiology
    },
    therapy14: {
        id: 14,
        therapy: 'Heat and Cold Therapy (Cryotherapy and Thermotherapy)',
        description: 'Heat therapy (thermotherapy) uses heat pads, wraps, or warm water to relax muscles and improve blood circulation. Cold therapy (cryotherapy) involves applying ice or cold packs to reduce swelling, numb pain, and manage acute injuries or inflammation.',
        benefits: [
            'Relieves muscle stiffness and spasms',
            'Improves blood flow to injured areas',
            'Provides relaxation and pain relief',
            'Reduces swelling and inflammation',
            'Numbs pain and provides acute injury management',
            'Slows down nerve activity to alleviate pain'
        ]
        ,
        whyChoose: 'Both heat and cold therapies are effective for managing different phases of injury recovery. Cold therapy is used during the acute phase to reduce inflammation and pain, while heat therapy is ideal for relaxing muscles and promoting circulation during the healing phase.',
        image1: Heat1,
        image2: Heat
    }
};

const TherapyDetail = () => {
    const { therapyId } = useParams();
    const therapy = services[therapyId];

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
        <Layout>
            <div className="therapy-detail" style={{ backgroundImage: `url(${bgim})` }}>
                <div className="top-section">
                    <div className="title-section">
                        <h1 >{therapy.therapy}</h1>
                        <p>{therapy.description}</p>
                    </div>
                </div>

                <div className="card-container">
                    <div className='block'>
                        <div className='image-of-therapy-box1'>
                            <img
                                className='image-of-therapy'
                                src={therapy.image2}
                                alt={`${therapy.therapy} image`} />
                        </div>
                        <div className="card benefits-card">
                            <h2>Benefits of {therapy.therapy}</h2>
                            <div className="square"></div>
                            <ul>
                                {therapy.benefits.map((benefit, index) => (
                                    <li key={index}>{benefit}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    
                    <div className='block'>
                        <div className="card why-choose-card">
                            <h2>Why Choose Mantraflex?</h2>
                            <div className='square'></div>
                            <p>{therapy.whyChoose}</p>
                        </div>
                        <div className='image-of-therapy-box2'>
                            <img
                                className='image-of-therapy'
                                src={therapy.image1}
                                alt={`${therapy.therapy} image`} />
                        </div>
                    </div>
                </div>
            </div>
            <QuotesSlider />
        </Layout>
    );
};

export default TherapyDetail;

